import React from 'react'

import { TableHeadCell, DataItem, SortSpan, TitleHelperTextSpan } from './TableHeadCell.styles'

import { CheckboxWrapperSpan } from '../tablecell/TableCell.styles'

import CustomCheckBox from '../../../checkbox'

import Tooltip from '../../../tooltip'

import { Icon } from '../../../../shared/tr-icons'

const TableCellComponent = ({ header, newStyle, className, sortStatus, subClassName, events, multiselect, count, headerChecked }) => {
  const checkboxProps = {
    'name': 'TableHeadCellCheckBox',
    'disableProperty': false,
    'partialCheckbox': false,
    'boxStatus': (headerChecked) ? 'selected' : 'default',
    'requiredProperty': false,
    'checkStatus': events.handleMultiSelectChanged
  }

  const showtitlehelpertext = header.titleHelperText ? 'showtitlehelpertext' : ''

  const innerclassName = (header.sortable && header.sortable.enabled && sortStatus && (sortStatus._order === 'asc' || sortStatus._order === 'desc'))
    ? 'showReactSort'
    : ''

  return (
    <TableHeadCell style={newStyle} className={className} data-testid='table-headercell'>

      <DataItem count={count} showtitlehelpertext={showtitlehelpertext} className={subClassName}>
        { count === 0 && multiselect && multiselect.showSelectAll &&
          <CheckboxWrapperSpan padding='2px 0 0 0'>
            {<CustomCheckBox {...checkboxProps} />}
          </CheckboxWrapperSpan>
        }

        { count === 0 && multiselect && !multiselect.showSelectAll &&
          <CheckboxWrapperSpan padding='2px 0 0 0' />            
        }
        <SortSpan>
          {header.title}
        </SortSpan>
        {header.titleHelperText &&
        <TitleHelperTextSpan className={showtitlehelpertext} data-testid='table-TitleHelperText'>
          <Tooltip text={header.titleHelperText} {...events} />
        </TitleHelperTextSpan>
        }
        <SortSpan onClick={events.handleSortClick} data-testid='table-sorter' className={innerclassName}>
          {header.sortable && header.sortable.enabled && sortStatus && sortStatus._order === 'asc' &&
            <Icon type='caretUp' />
          }
          {header.sortable && header.sortable.enabled && sortStatus && sortStatus._order === 'desc' &&
            <Icon type='caretDown' />
          }
          {header.sortable && header.sortable.enabled && !sortStatus &&
            <Icon type='caretUp' />
          }
        </SortSpan>
      </DataItem>
    </TableHeadCell>
  )
}

export default TableCellComponent
